import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar } from 'lucide-react';
import { useTimezone } from '@/contexts/TimezoneContext';
import { generateMonthOptions } from '@/utils/monthOptions';
import { useMemo } from 'react';

interface ExpenseMonthFilterProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
}

export const ExpenseMonthFilter = ({
  selectedMonth,
  onMonthChange,
}: ExpenseMonthFilterProps) => {
  const { timezone } = useTimezone();
  
  const monthOptions = useMemo(() => generateMonthOptions(timezone), [timezone]);

  // Find the label for current selection
  const selectedLabel = monthOptions.find(m => m.value === selectedMonth)?.label || selectedMonth;

  return (
    <div className="flex items-center gap-3 p-3 bg-muted/30 rounded-lg border">
      <Calendar className="h-4 w-4 text-muted-foreground" />
      <Select value={selectedMonth} onValueChange={onMonthChange}>
        <SelectTrigger className="w-[200px] h-9 font-medium">
          <SelectValue>{selectedLabel}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {monthOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
